import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import moment from 'moment-timezone';
import { shortDatetime } from 'Consts/DateFormats';

const styles = (theme) => ({
  root: {
    marginRight: theme.spacing(0.5),
    backgroundColor: theme.palette.facet.accentBlue20,
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightFacetBold,
    margin: theme.spacing(0.25),
  },
});

const ReadOnlyScenarioChip = ({
  className,
  classes,
  resource,
}) => {
  return (
    <Chip
      className={classNames(classes.root, className)}
      label={`Read Only - Last Updated ${moment.utc(resource.attr('lastUpdated')).local().format(shortDatetime)}`}
      disabled
    />
  );
};

ReadOnlyScenarioChip.defaultProps = {
  className: '',
};

ReadOnlyScenarioChip.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(ReadOnlyScenarioChip);
